import { IFilterMarquesSearch } from '../../../../models/interfaces/IFilterMarquesSearch';
import { ServiceApplication_Key } from "../../../../config/helpers";
import { IFilterSociete } from "../../../../models/interfaces/IFilterSociete";
import { ISocieteActeursJuridiquesReturn, ISocieteCompteReturn, ISocieteMarquesReturn, ISocieteUpdateActeursJuridiques, ISocieteUpdateMarques, ISocieteUpdateModules, ISocietesCompteReturn } from "../../../../models/interfaces/ISociete";

import { apiSlice } from "../../api";
import { IFilterActeursJuridiquesSearch } from '../../../../models/interfaces/IFilterActeursJuridiquesSearch';
import { IFormSociete } from '../../../../models/interfaces/IFormOrganisation';


export interface societeApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export const societeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBOSocietesCompte: builder.query<ISocietesCompteReturn, IFilterSociete|undefined>({
      query: (obj) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/BO/Societe/Societe_Compte_Search",
          method: "POST",
          body: body,
        };
      },
    }),
       
    fetchBOSocieteCompte: builder.query<ISocieteCompteReturn, number>({
      query: (IdSociete: number) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {IdSociete: IdSociete},
        };
        return {
          url: "/BO/Societe/Societe_Compte_Get",
          method: "POST",
          body: body,
        };
      },
    }),


    fetchBOSocieteMarques: builder.query<ISocieteMarquesReturn, number>({
      query: (pIdsociete: number) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {Idsociete: pIdsociete},
        };
        return {
          url: "/BO/Societe/Societe_GetMarques",
          method: "POST",
          body: body,
        };
      },
    }),

    fetchBOSocieteActeursJuridiques: builder.query<ISocieteActeursJuridiquesReturn, number>({
      query: (pIdsociete: number) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {Idsociete: pIdsociete},
        };
        return {
          url: "/BO/Societe/Societe_GetActeursJuridiques",
          method: "POST",
          body: body,
        };
      },
    }),

    fetchBOSocieteAllMarques: builder.query<ISocieteMarquesReturn, number>({
      query: (pIdsociete: number) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {Idsociete: pIdsociete},
        };
        return {
          url: "/BO/Societe/Societe_GetAllMarques",
          method: "POST",
          body: body,
        };
      },
    }),



    searchBOSocieteMarques: builder.query<ISocieteMarquesReturn, IFilterMarquesSearch|undefined>({
      query: (MarqueSearch: IFilterMarquesSearch|undefined) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: MarqueSearch ? MarqueSearch : {},
        };
        return {
          url: "/BO/Societe/Societe_Marques_Search",
          method: "POST",
          body: body,
        };
      },
    }),

    searchBOSocieteActeurJuridique: builder.query<ISocieteActeursJuridiquesReturn, IFilterActeursJuridiquesSearch|undefined>({
      query: (ActeursJuridiquesSearch: IFilterActeursJuridiquesSearch|undefined) => { 
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: ActeursJuridiquesSearch ? ActeursJuridiquesSearch : {},
        };
        return {
          url: "/BO/Societe/Societe_ActeursJuridiques_Search",
          method: "POST",
          body: body,
        };
      },
    }),

    
    BOSocieteUpdateMarques: builder.mutation<ISocieteMarquesReturn, ISocieteUpdateMarques>({
      query: (data:ISocieteUpdateMarques) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Societe/Societe_UpdateMarques",
          method: "POST",
          body: body,
        };
      },
    }),

    
    BOSocieteUpdateActeursJuridiques: builder.mutation<ISocieteActeursJuridiquesReturn, ISocieteUpdateActeursJuridiques>({
      query: (data:ISocieteUpdateActeursJuridiques) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Societe/Societe_UpdateActeursJuridiques",
          method: "POST",
          body: body,
        };
      },
    }),
    BOSocieteCompteUpdate: builder.mutation<ISocieteCompteReturn, IFormSociete>({
      query: (data) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Societe/Societe_Compte_Update",
          method: "POST",
          body: body,
        };
      },
    }),

    BOSocieteUpdateModules: builder.mutation<ISocieteCompteReturn, ISocieteUpdateModules>({
      query: (data:ISocieteUpdateModules) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/BO/Societe/Societe_UpdateModules",
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFetchBOSocietesCompteQuery,
  useFetchBOSocieteCompteQuery,
 
  useSearchBOSocieteActeurJuridiqueQuery,
  useSearchBOSocieteMarquesQuery,
  
  
  useFetchBOSocieteMarquesQuery,
  useFetchBOSocieteActeursJuridiquesQuery,
  useFetchBOSocieteAllMarquesQuery,
  useLazyFetchBOSocieteAllMarquesQuery,

  useBOSocieteUpdateMarquesMutation,
  useBOSocieteUpdateActeursJuridiquesMutation,
  useBOSocieteCompteUpdateMutation,
  useBOSocieteUpdateModulesMutation,

} = societeApi;
